import { PageLayout } from '@/layouts/page-layout'
import { Form, Formik } from 'formik'
import { Button } from '@material-tailwind/react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useCreateUserMutation } from '@/store/services'
import { list } from '@/router/utils'
import { useEffect, useState } from 'react'
import { useAuthorization } from '@/hooks'
import { validationSchema as generateValidateSchema } from './schema-validation'
import { UserCompanyInformationForm, UserPersonalInformationForm } from './forms'

export const UserCreate = () => {
  const [selectedRole, setSelectedRole] = useState({})
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })

  const { t } = useTranslation()
  const navigate = useNavigate()
  const [createUser, { isLoading }] = useCreateUserMutation()
  const initialValues = {
    first_name: null,
    last_name: null,
    email: null,
    document_number: null,
    phone: null,
    role_ids: [],
    resource_type: null,
    resource_id: null,
    account_office_id: null,
    account_managment_id: null,
    has_local_document_number: true
  }

  const onSubmit = async (values) => {
    try {
      await createUser(values).unwrap()

      navigate(list('users'))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    hasAccess('user#create')
  }, [])

  return (
    <PageLayout title={t('actions.create.with', { what: t('user.one') })}>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={generateValidateSchema(selectedRole?.name || '')} validateOnChange>
        <Form >
          <UserPersonalInformationForm setSelectedRole={setSelectedRole} />
          <UserCompanyInformationForm />

          <div className='flex justify-end gap-3 mt-10'>
            <Link to={list('users')}>
              <Button variant='text' type='submit'>
                {t('actions.cancel')}
              </Button>
            </Link>

            <Button type='submit' loading={isLoading}>
              {t('actions.create.one')}
            </Button>
          </div>
        </Form>
      </Formik>
    </PageLayout>
  )
}
